import type { StatBlock, UnitView } from "./types.js";

export const COMPARE_STATS: (keyof StatBlock | "power")[] = ["power", "hp", "atk", "def", "intervalTicks", "crit", "critDmg", "acc", "eva", "energyPerAttack", "cargo"];
export function comparisonRows(before: UnitView, after: UnitView) {
  return COMPARE_STATS.map((key) => {
    const oldValue = key === "power" ? before.power : before.stats[key];
    const newValue = key === "power" ? after.power : after.stats[key];
    const delta = newValue - oldValue;
    return { key, before: oldValue, after: newValue, delta, direction: delta === 0 ? "same" : delta * (key === "intervalTicks" ? -1 : 1) > 0 ? "up" : "down" };
  });
}
